import {Contador} from './services/Contador.ts';
import type {PontoTipo} from './types/Ponto.ts';
import {pontoTipo} from './types/Ponto.ts';
import { type AuthContextProps } from 'react-oidc-context';
import { Events } from './services/Events.ts';
import type { PontoEvent } from './types/PontoEvent.ts';

export class Controller {
    public playContador: Contador;
    public pauseContador: Contador;
    private user: string;
    private events: Events;
    constructor(auth: AuthContextProps, events?: PontoEvent[]) {
        if (!auth.isAuthenticated || !auth.user?.profile) {
            throw new Error('User is not authenticated');
        }
        this.events = new Events(auth, events);
        if (!events) {
            events = this.events.get();
        }
        const obj = this.calculateContadores(
            events
        )
        
        this.playContador = obj.playContador;
        this.pauseContador = obj.pauseContador;
        this.user = auth.user?.profile.email || 'anonymous';

    }
    public getUser(): string {
        return this.user;
    }

    protected calculateContadores(events: PontoEvent[]): { playContador: Contador; pauseContador: Contador; } {
        let playBuffer = 0;
        let pauseBuffer = 0;
        let playStartTime: Date | null = null;
        let pauseStartTime: Date | null = null;

        for (const event of events) {
            if (event.tipo === pontoTipo.INICIO) {
                if (pauseStartTime) {
                    pauseBuffer += (event.dataHora.getTime() - pauseStartTime.getTime()) / 1000;
                    pauseStartTime = null;
                }
                playStartTime = event.dataHora;
            } else if (event.tipo === pontoTipo.PAUSA || event.tipo === pontoTipo.FIM) {
                if (playStartTime) {
                    playBuffer += (event.dataHora.getTime() - playStartTime.getTime()) / 1000;
                    playStartTime = null;
                }
                if (event.tipo === pontoTipo.PAUSA) {
                    pauseStartTime = event.dataHora;
                } else if (event.tipo === pontoTipo.FIM) {
                    pauseStartTime = null;
                }
            }
        }

        const isPlayActive = playStartTime !== null;
        const isPauseActive = pauseStartTime !== null;

        return {
            playContador: new Contador(Math.floor(playBuffer), playStartTime || new Date(), isPlayActive),
            pauseContador: new Contador(Math.floor(pauseBuffer), pauseStartTime || new Date(), isPauseActive)
        };
    }
    private shouldPushEvent(tipo: PontoTipo): boolean {
        if (tipo === pontoTipo.INICIO) {
            return !this.playContador.ativo;
        } else if (tipo === pontoTipo.PAUSA) {
            return !this.pauseContador.ativo;
        } else if (tipo === pontoTipo.FIM) {
            return this.playContador.ativo || this.pauseContador.ativo;
        }
        return false;
    }

    pushEvent(dataHora: Date, tipo: PontoTipo): void {
        if (this.shouldPushEvent(tipo)) {
            this.updateContadores(dataHora, tipo);
            this.events.add({ dataHora, tipo });
        }
    }

    protected updateContadores(dataHora: Date, tipo: PontoTipo): void {
        if (tipo === pontoTipo.INICIO) {
            this.playContador.iniciaContagem(dataHora);
            if (this.pauseContador.ativo) {
                this.pauseContador.pausaContagem(dataHora);
            }
        } else if (tipo === pontoTipo.PAUSA) {
            this.pauseContador.iniciaContagem(dataHora);
            if (this.playContador.ativo) {
                this.playContador.pausaContagem(dataHora);
            }
        } else if (tipo === pontoTipo.FIM) {
            if (this.playContador.ativo) {
                this.playContador.pausaContagem(dataHora);
            }
            if (this.pauseContador.ativo) {
                this.pauseContador.pausaContagem(dataHora);
            }
        }
    }
}

